module.exports = __webpack_public_path__ + "static/img/icon_message.90590d56.svg";